import { IFilter } from '../../interfaces/Filter.interfaces';

// 체크박스를 하나도 고르지 않았거나 모두 고른 것은 조회 결과가 같아 '전체'로 본다.
// 옵션이 하나뿐인 체크박스(최근 7일 토글)는 켜고 끄는 값이라 해당하지 않는다.
export const isFilterSelectedAsAll = (filter: IFilter): boolean => {
  if (filter.optionType !== 'checkbox' || filter.options.length <= 1) {
    return false;
  }

  const selectedOptionCount = filter.options.filter((option) => option.isSelected).length;

  return selectedOptionCount === 0 || selectedOptionCount === filter.options.length;
};
